import { apiSdk } from '@/httpClient';
import { AppEnvSetting, HIDE_MESSAGE_401_PARAMS, SSO_URL_MAPPING } from '@/config';
import { AppUrls } from '@/urls';

const accessTokenKey = 'a-s-token-id';
const refreshTokenKey = 'a-s-rtoken-id';
interface LoginInfo {
  token: string;
  userId: string;
}
class AuthService {
  redirect2LogoutPage = () => {
    window.location.href = AppUrls.Logout;
  };
  clearInfoWhenLogout = async () => {
    try {
      await apiSdk.AgentUserService.logoff({ params: { [HIDE_MESSAGE_401_PARAMS]: true } });
    } catch (error) {}
    this.clearOnLogout();
  };
  clearOnLogout = () => {
    localStorage.removeItem(accessTokenKey);
    localStorage.removeItem(refreshTokenKey);
  };
  getAccessToken = () => {
    try {
      const info: LoginInfo | null = JSON.parse(localStorage.getItem(accessTokenKey) || '');
      return info?.token;
    } catch (error) {
      return null;
    }
  };
  getLoginInfo = () => {
    try {
      const info: LoginInfo | null = JSON.parse(localStorage.getItem(accessTokenKey) || '');
      return info;
    } catch (error) {
      return null;
    }
  };
  saveLoginInfo = (info: LoginInfo) => {
    localStorage.setItem(accessTokenKey, JSON.stringify(info));
  };

  saveRefreshToken = (token: string) => {
    localStorage.setItem(refreshTokenKey, token);
  };

  getRefreshToken = () => {
    try {
      return localStorage.getItem(refreshTokenKey);
    } catch (ex) {
      return null;
    }
  };
  redirect2MiyabiLoginUrl = (returnUrl: string, token: string, isNewTab: boolean) => {
    let redirectUrl: string = SSO_URL_MAPPING[returnUrl] || returnUrl;
    if (!redirectUrl.startsWith('http')) {
      redirectUrl = 'https://' + redirectUrl;
    }
    let url = new URL(redirectUrl);
    url.searchParams.append('token', token);
    if (isNewTab) {
      window.open(url.href, '_blank');
    } else {
      window.location.href = url.href;
    }
  };
  generateTokenAndRedirect2Miyabi = (returnUrl: string, isNewTab: boolean, event?: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (event) {
      event.preventDefault();
    }
    console.log(process.env.REACT_DISABLE_SSO);
    if (AppEnvSetting.disableSso) {
      if (isNewTab) {
        window.open(returnUrl, '_blank');
      } else {
        window.location.href = returnUrl;
      }
    } else {
      apiSdk.MiyabiAuthService.generateAuthToken().then(res => {
        this.redirect2MiyabiLoginUrl(returnUrl, res, isNewTab);
      });
    }
  };
  logUserInfo2Sentry = (userId: string | undefined, email: string | undefined, username: string | undefined) => {};
}
const authService = new AuthService();
export default authService;
